import { proxy } from 'valtio'

const state = proxy({
  menu: [],
  logo: '',
  site_name:'',
  home_page_id: '',
  home_page_type: '',
  page_loaded:false,
  last_link_selected: {}
})
export default state
